import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'

import { ErrorBoundary } from '../components/ErrorBoundary'
import { BusinessRequestModal } from '../components/BusinessRequestModal'

import '../i18n'
import '../components/App.css'

// Kyb Business Request Params
import KybParams from '../components/kyb_business_request.json'

const App = () => {
  let kybParams = JSON.parse((document.getElementById('kyb_params') as HTMLInputElement)?.value || JSON.stringify(KybParams));

  return (
    <ErrorBoundary>
      <BusinessRequestModal {...kybParams} />
    </ErrorBoundary>
  )
}

createRoot(document.getElementById('kyb_app')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
) 